import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { DialogResult, DialogService } from 'dspx-core';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

// https://stackoverflow.com/a/41187919
@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  unsavedChangesPopup = [
    {
      'code': 'UnsavedChanges',
      'title': 'Unsaved changes',
      'text': '<p>WARNING: You have unsaved changes.</p><p>Press Cancel to go back and save these changes, or OK to discard these changes.</p>',
      'type': 'error',
      'onCloseFocusElementId': '',
      'okButtonText': 'OK',
      'cancelButtonText': 'Cancel'
    }];

  constructor(private dialogService: DialogService) { }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {

    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate() ?
      true :

      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      //confirm('WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
      this.openConfirmDialog();
  }

  openConfirmDialog(): Observable<boolean> {

    this.dialogService.setPopups(this.unsavedChangesPopup);

    return this.dialogService.showConfirmPopup('UnsavedChanges')
      .pipe(map((data) => {
        if (data === DialogResult.REJECTED) {
          return false;
        }
        return true;
      }));
  }
}
